import React from 'react';
import PropTypes from 'prop-types';

import NetworksIconsBar from '../../../common/networks-icons-bar/networks-icons-bar';
import './team-member-main.css';

const TeamMemberMain = ({ name, description, ...rest }) => {
  return (
    <div className='team-member-main'>
      <NetworksIconsBar rawIconsData = { rest } />

      <div className='about'>
        {/*<h3 className='page-title'>
          ABOUT ME
        </h3>*/}

        {/*<hr className='title-separator' />*/}

        <div className='about-parts'>
          { 
            description && description.length > 0 && 
              <div className='about-part'>
                { description.slice(0, 2).map((p, i) => <p key={ i }>{ p }</p>) }
              </div>
          }

          { 
            description && description.length > 2 && 
              <div className='about-part'>
                { description.slice(2, 4).map((p, i) => <p key={ i }>{ p }</p>) }
              </div>
          }
        </div>
      </div> 
    </div>
  );
};

TeamMemberMain.propTypes = {
  name: PropTypes.string.isRequired,
  twitterUserId: PropTypes.string,
  description: PropTypes.arrayOf(PropTypes.string),
};

export default TeamMemberMain;